import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import initialState from './initialState'

export default {
  namespaced: true,
  state: initialState(),
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/buyer/index.js